<template>
  <div class="stories-list" :class="type">
    <div class="header" :class="{ active: visible }" @click="setActive">
      {{ type }}
    </div>
    <div :class="{ hidden: !visible }" class="scroll-box">
      <vuescroll :ops="scrollSettings">
        <router-link v-for="(story, index) in items" :key="`story-${index}`" :to="story.link">
          <div class="story-box">
            <div class="left-tab">
              <div class="text">
                {{ story.program }}
              </div>
            </div>
            <div class="reveal" :style="`background-image: url(${story.image || ''})`">
              <video v-if="story.video" :src="story.video" autoplay loop muted />
            </div>
            <div class="story-title">
              <h1>{{ story.title }}</h1>
            </div>
            <!-- <img v-if="story.type" class="type-icon" :src="`images/${story.type}.png`" alt="Story type"> -->
            <!-- <img class="link-arrow" src="images/story-link-arrow.svg" alt="Arrow"> -->
          </div>
        </router-link>
      </vuescroll>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll'
export default {
  props: {
    items: {
      type: Array,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      scrollSettings: {
        rail: {
          size: '18px',
          gutterOfSide: '0px',
          background: '#05162a',
          specifyBorderRadius: '0px',
          opacity: 1
        },
        bar: {
          size: '12px',
          background: '#defaff',
          onlyShowBarOnScroll: false,
          keepShow: true
        }
      }
    }
  },
  components: {
    vuescroll
  },
  methods: {
    setActive () {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

.header {
  position: relative;
  text-transform: uppercase;
  text-align: center;
  padding: $space-xs;
  border: solid $brand-light-blue;
  background-color: $brand-dark-blue;
  border-width: 2px;
  pointer-events: all;
  font-size: 15px;

  @include media($bp-tablet) {
    width: 50%;
    cursor: pointer;
    display: inline-block;
    border-color: transparent;

    padding: 4px;
    transition: .3s all;
    transform-origin: bottom right;

    &::after {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      border: solid 2px $brand-light-blue;
      transition: .3s all;
    }

    &.active::after {
      top: -6px;
      height: calc(100% + 8px);
      transition: .3s all;
    }
  }
}
.stories-list {
  height: calc(100% - 44px);
  pointer-events: none;
  
  @include media($bp-tablet) {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 24px;
  }
  &.stories {
    .header {
      border-right-width: 1px;
      transform-origin: bottom left;
      
      &::after {
        border-radius: 8px 0 0 0;
      }

      &.active::after {
        border-radius: 0 8px 0 0;
      }
    }
    .scroll-box {
      border-right-width: 1px;
      @include media($bp-tablet) {
        border-right-width: 2px;
      }
    }
  }
  &.articles {
    .header {
      border-left-width: 1px;

      &::after {
        border-radius: 0 8px 0 0;
      }

      &.active::after {
        border-radius: 8px 0 0 0;
      }

      @include media($bp-tablet) {
        transform: translateX(100%);
      }
    }
    .scroll-box {
      border-left-width: 1px;
      @include media($bp-tablet) {
        border-left-width: 2px;
      }
    }
  }
  .scroll-box {
    position: relative;
    height: 100%;
    border: solid $brand-light-blue;
    border-width: 0 2px 2px 2px;
    pointer-events: all;

    @include media($bp-tablet) {
      &.hidden {
        opacity: 0;
        pointer-events: none;
      }
    }

    ::v-deep .__rail-is-vertical {
      border-left: solid 2px $brand-light-blue !important;
    }

    ::v-deep .__bar-is-vertical {
      border: solid $brand-dark-blue;
      border-width: 2px 0;
    }
  }
  a {
    color: $brand-light-blue;
    &:first-child .story-box {
      border-top: 0;
    }
  }
  .story-box {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: solid $brand-light-blue;
    border-width: 0 0 2px 0;
    height: 150px;

    @include media($bp-desktop-xxl) {
      height: 120px;
    }

    &:hover {
      .reveal {
        width: 300px;
        transition: .3s all;

        @include media($bp-hd) {
          width: 200px;
        }

        @include media($bp-desktop-l) {
          width: 100%;
        }
      }
    }
    > div {
      vertical-align: bottom;
      display: inline-block;
    }
    .left-tab {
      z-index: 1;
      font-size: 15px;
      line-height: 1.2;
      border-right: solid 2px $brand-light-blue;
      position: relative;
      text-align: center;
      text-transform: uppercase;
      width: 100px;
      height: 100%;
      .text {
        @include center-in-parent;
        transform: translate(-50%, -50%) rotateZ(-90deg);
      }

      @include media($bp-desktop-xxl) {
        font-size: 14px;
        width: 60px;
      }

      @include media($bp-phone-l) {
        font-size: 9px;
        width: 40px;
      }
    }
    .reveal {
      position: relative;
      width: 0;
      height: 100%;
      background-position: center center;
      background-size: cover;
      border-right: solid 2px $brand-light-blue;
      overflow: hidden;
      transform: translateX(-2px);
      transition: .3s all;

      @include media($bp-desktop-l) {
        position: absolute;
      }

      video {
        @include center-in-parent;
        min-height: 100%;
        min-width: 100%;
      }
    }
    .story-title {
      position: relative;
      width: 100%;
      height: 100%;
      max-width: calc(100% - 400px);
      h1{
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
        font-family: $font-title-regular;
        font-size: 70px;
        text-transform: none;
        white-space: nowrap;
      }

      @include media($bp-hd) {
        max-width: calc(100% - 500px);
        h1 {
          font-size: 60px;
        }
      }

      @include media($bp-desktop-xxl) {
        h1 {
          font-size: 40px;
        }
      }

      @include media($bp-desktop-l) {
        max-width: calc(100% - 100px);
        h1 {
          left: 15px;
          line-height: 1;
          white-space: normal;
        }
      }

      @include media($bp-desktop-s) {
        h1 {
          font-size: 30px;
        }
      }

      @include media($bp-phone-l) {
        max-width: calc(100% - 55px);
        h1 {
          left: 10px;
        }
      }
    }
    .link-arrow {
      position: absolute;
      top: 60px;
      right: 60px;
      width: 60px;

      @include media($bp-desktop-xxl) {
        top: 40px;
        right: 40px;
      }

      @include media($bp-tablet) {
        display: none;
      }
    }

    .type-icon {
      position: absolute;
      top: 40px;
      right: 180px;
      height: calc(100% - 80px);

      @include media($bp-desktop-xxl) {
        right: 140px;
      }
      @include media($bp-tablet) {
        height: calc(100% - 60px);
        top: 30px;
        right: 30px;
      }
      @include media($bp-phone-l) {
        height: calc(100% - 80px);
        top: 40px;
      }
    }
  }
}
</style>
